// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\UploadPublicTokenResponse

export type UploadPublicTokenApiResponse = {
	token: string;
	url: string;
};

export type UploadPublicToken = {
	token: string;
	url: string;
};

export function hydrateUploadPublicToken(data: UploadPublicTokenApiResponse): UploadPublicToken {
	return { ...data };
}